import React from 'react';

const SharedCalGuide = () => {

    return (
        <div className="SharedCalGuide">
            <div className="descript-container collapse" id="collapseCal">
                Set a date range to specify results within 3 months.
            </div>
        </div>
    );
};

export default SharedCalGuide;
